// Scalable SEO destination pages data
// Each route becomes /taxi-lushnje-<slug>
// Add new routes here — the RouteDetail component handles rendering automatically

export const ROUTES = {
  dhermi: {
    origin: "Lushnje",
    destination: "Dhërmi",
    slug: "taxi-lushnje-dhermi",
    price_all: 7500,
    price_eur: 75,
    distance_km: 145,
    duration_text: "Rreth 2 orë e 30 minuta",
    hero_image: "https://customer-assets-4nw71qhi.emergentagent.net/job_brothers-taxi-web/artifacts/q718vh2m_byd%20sarande%20brotherstaxi.png",
    destination_image: "https://customer-assets-4nw71qhi.emergentagent.net/job_brothers-taxi-web/artifacts/q718vh2m_byd%20sarande%20brotherstaxi.png",
    intro:
      "Udhëtoni drejt Dhërmiut me automjet privat, shofer profesional dhe çmim të konfirmuar përpara nisjes.",
    overview: [
      "Ky shërbim është i përshtatshëm për familje, çifte dhe grupe të vogla që kërkojnë një transport të drejtpërdrejtë nga Lushnja drejt Dhërmiut, pa ndalesa të panevojshme dhe pa ndarë automjetin me pasagjerë të tjerë.",
      "Marrja mund të organizohet nga një adresë e caktuar në Lushnje (banesa, hotel, qendra, stacioni i autobusëve), ndërsa mbërritja bëhet deri në hotelin, apartamentin, plazhin apo adresën private në Dhërmi. Nëse keni bagazhe të mëdha, kërkesa për ndalesa gjatë rrugës, ose udhëtim të kthimit, na e bëni të ditur gjatë rezervimit.",
    ],
    pickup_areas: [
      "Qendra e Lushnjes",
      "Stacioni i autobusëve",
      "Hotel ose banesë private",
      "Zona përreth sipas marrëveshjes",
    ],
    arrival_areas: [
      "Dhërmi fshat",
      "Plazhi i Dhërmiut",
      "Drymades",
      "Hotel, apartament ose vilë private",
    ],
    destination_content: [
      "Dhërmiu është një nga destinacionet më të vizituara të bregdetit jugor. Brothers Taxi mund t'ju dërgojë deri në hotel, apartament, zonën e plazhit ose Drymades, sipas adresës së konfirmuar gjatë rezervimit.",
      "Gjatë sezonit veror trafiku mund të rritet, kryesisht në orët e mbrëmjes. Përcaktoni adresën e saktë të mbërritjes gjatë rezervimit dhe njoftoni për bagazhe të mëdha ose kërkesa të veçanta. Transporti i kthimit mund të organizohet paraprakisht.",
    ],
    faqs: [
      {
        q: "Sa zgjat udhëtimi nga Lushnja në Dhërmi?",
        a: "Kohëzgjatja mesatare është rreth 2 orë e 30 minuta, në varësi të kushteve të trafikut dhe sezonit.",
      },
      {
        q: "Sa kushton taxi nga Lushnja drejt Dhërmiut?",
        a: "Çmimi bazë për një automjet privat, një drejtim, është 7,500 Lekë. Çmimi konfirmohet përpara nisjes.",
      },
      {
        q: "A është çmimi për person apo për automjet?",
        a: "Çmimi është për automjet, jo për person. Deri në 4 pasagjerë udhëtojnë me të njëjtin çmim.",
      },
      {
        q: "A mund të rezervoj edhe udhëtimin e kthimit?",
        a: "Po. Mund të organizohet një udhëtim kthimi me datë dhe orë të përcaktuar. Na e komunikoni në kohën e rezervimit.",
      },
      {
        q: "A mund të kërkoj një ndalesë gjatë rrugës?",
        a: "Po, ndalesat e shkurtra janë të mundshme. Për ndalesa më të gjata mund të aplikohet tarifë shtesë pritjeje.",
      },
      {
        q: "Sa bagazhe mund të marrim?",
        a: "Në varësi të automjetit, mund të transportohen 3–4 valixhe standarde. Për bagazhe të veçanta, na njoftoni paraprakisht.",
      },
    ],
    related: ["vlore", "himare", "sarande", "ksamil", "aeroporti-tiranes", "divjake"],
  },
  vlore: {
    origin: "Lushnje",
    destination: "Vlorë",
    slug: "taxi-lushnje-vlore",
    price_all: 5000,
    price_eur: 50,
    distance_km: 70,
    duration_text: "Rreth 1 orë",
    hero_image: "https://images.unsplash.com/photo-1596395464663-3ec97ab5cf6b?auto=format&fit=crop&w=2000&q=80",
  },
  himare: {
    origin: "Lushnje",
    destination: "Himarë",
    slug: "taxi-lushnje-himare",
    price_all: 8500,
    price_eur: 85,
    distance_km: 165,
    duration_text: "Rreth 3 orë",
  },
  sarande: {
    origin: "Lushnje",
    destination: "Sarandë",
    slug: "taxi-lushnje-sarande",
    price_all: 9000,
    price_eur: 90,
    distance_km: 220,
    duration_text: "Rreth 3 orë e 30 minuta",
  },
  ksamil: {
    origin: "Lushnje",
    destination: "Ksamil",
    slug: "taxi-lushnje-ksamil",
    price_all: 10000,
    price_eur: 100,
    distance_km: 235,
    duration_text: "Rreth 3 orë e 40 minuta",
  },
  "aeroporti-tiranes": {
    origin: "Lushnje",
    destination: "Aeroporti i Tiranës",
    slug: "taxi-lushnje-aeroporti-tiranes",
    price_all: 3500,
    price_eur: 35,
    distance_km: 100,
    duration_text: "Rreth 1 orë e 15 minuta",
  },
  divjake: {
    origin: "Lushnje",
    destination: "Divjakë",
    slug: "taxi-lushnje-divjake",
    price_all: 1500,
    price_eur: 15,
    distance_km: 20,
    duration_text: "Rreth 25 minuta",
  },
  tirane: {
    origin: "Lushnje",
    destination: "Tiranë",
    slug: "taxi-lushnje-tirane",
    price_all: 4000,
    price_eur: 40,
    distance_km: 85,
    duration_text: "Rreth 1 orë",
    hero_image: "https://customer-assets-4nw71qhi.emergentagent.net/job_brothers-taxi-web/artifacts/qk1lsm67_brothers%20taxi%20tirana.png",
    destination_image: "https://customer-assets-4nw71qhi.emergentagent.net/job_brothers-taxi-web/artifacts/qk1lsm67_brothers%20taxi%20tirana.png",
    intro: "Udhëtoni drejt Tiranës me automjet privat, shofer profesional dhe çmim të konfirmuar përpara nisjes.",
    destination_content: [
      "Tirana është kryeqyteti dhe qendra kryesore ekonomike, kulturore dhe akademike e Shqipërisë. Brothers Taxi ju dërgon deri në hotel, apartament, sheshin qendror, universitet, spital ose adresë private të përcaktuar.",
      "Për takime biznesi, vizita mjekësore ose udhëtime studimore, ne organizojmë transport të drejtpërdrejtë me kohë të parashikueshme dhe mundësi rezervimi për udhëtimin e kthimit.",
    ],
    arrival_areas: [
      "Sheshi Skënderbej",
      "Blloku dhe qendra e Tiranës",
      "Universitetet dhe spitalet kryesore",
      "Hotel, apartament ose adresë private",
    ],
  },
  berat: {
    origin: "Lushnje",
    destination: "Berat",
    slug: "taxi-lushnje-berat",
    price_all: 2000,
    price_eur: 20,
    distance_km: 50,
    duration_text: "Rreth 50 minuta",
    hero_image: "https://customer-assets-4nw71qhi.emergentagent.net/job_brothers-taxi-web/artifacts/ig5wsq8h_3018e6f3-daf1-467f-8f3d-09655d67e6f3.png",
    destination_image: "https://customer-assets-4nw71qhi.emergentagent.net/job_brothers-taxi-web/artifacts/ig5wsq8h_3018e6f3-daf1-467f-8f3d-09655d67e6f3.png",
    intro: "Udhëtoni drejt Beratit, qytetit të një mijë e një dritareve, me automjet privat dhe çmim të konfirmuar përpara nisjes.",
    destination_content: [
      "Berati është një qytet i mbrojtur nga UNESCO, i njohur për arkitekturën e vjetër osmane, kalanë historike dhe pamjet mbresëlënëse mbi Osumin. Brothers Taxi ju dërgon deri në hotelin, apartamentin, kalanë e Beratit ose adresën private të përcaktuar.",
      "Rruga Lushnje–Berat është relativisht e shkurtër dhe komode. Për vizita ditore, mund të rezervoni edhe udhëtimin e kthimit sipas orarit që ju përshtatet.",
    ],
    arrival_areas: [
      "Kalaja e Beratit",
      "Mangalem – lagjja historike",
      "Gorica",
      "Hotel, apartament ose vilë private",
    ],
  },
};

export const getRoute = (slug) => ROUTES[slug] || null;
